module.exports = __webpack_public_path__ + "img/Steor-Icons-01.64874c88.svg";